import DataTableBase from "../../shared/DataTableBase";
import { DateFormat } from "../../Helper";
import patientService from "../../services/patient.service";
import { useEffect, useState, useCallback, useMemo } from "react";
import DemographicInfo from "../../shared/users/DemographicInfo.js";
import Loader from "../../shared/Loading.js";
import { Link } from "react-router-dom";
import { GoUnverified, GoVerified } from "react-icons/go";
import _debounce from "lodash/debounce";

const columns = [
  {
    name: "Kapid Id",
    selector: (row) => row.user_kapid_id,
    sortable: true,
    sortField: "user_kapid_id",
  },
  {
    name: "Code",
    selector: (row) => row.patient[0].bp_patient_code,
    sortable: true,
    sortField: "user_kapid_id",
  },
  {
    name: "Name",
    selector: (row) => row.full_name,
    sortable: true,
    sortField: "full_name",
    format: (row) => (
      <Link
        to={`/patient/${row.user_kapid_id}`}
        className="text-decoration-none"
      >
        {row.full_name}
      </Link>
    ),
  },
  {
    name: "DoB",
    selector: (row) => row.dob,
    format: (row) => <DateFormat value={row.dob} />,
    sortable: true,
    sortField: "dob",
  },
  {
    name: "Gender",
    selector: (row) => row.gender,
    sortable: true,
    sortField: "gender",
  },
  {
    name: "Contact",
    selector: (row) => row.mobile,
    format: (row) => (
      <span>
        {row.mobile}&nbsp;
        {row.mobile && row?.mobile_verified === 1 && (
          <span className="text-success">
            <GoVerified />
          </span>
        )}
        {row.mobile && row?.mobile_verified !== 1 && (
          <span className="text-danger">
            <GoUnverified />
          </span>
        )}
      </span>
    ),
  },
];
const PatientList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const fetchList = async (
    page,
    _perPage,
    sorting_column = null,
    sorting_direction = null
  ) => {
    setLoading(true);
    const response = await patientService.patientList(
      page,
      _perPage,
      sorting_column,
      sorting_direction
      //   search_text
    );

    setData(response.data);
    setTotalRows(response.total);
    setLoading(false);
  };

  const handlePageChange = (page) => {
    fetchList(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    await fetchList(page, newPerPage);
    setPerPage(newPerPage);
  };
  const handleSort = async (column, sortDirection) => {
    // simulate server sort
    console.log(column, sortDirection);
    await fetchList(1, perPage, column.sortField, sortDirection);
  };
  useEffect(() => {
    fetchList(1, perPage); // fetch page 1 of users
  }, []);
  const ExpandedComponent = ({ data }) => {
    const [demographicLoading, setDemographicLoading] = useState(true);
    const [demographic, setDemographic] = useState({});
    const controller = useMemo(() => {
      return new AbortController();
    }, [data.user_kapid_id]);
    const fetchData = async () => {
      setDemographicLoading(true);
      const response = await patientService.getPatientUser(
        data.user_kapid_id,
        controller
        // source.token
      );
      // console.log(response);
      setDemographic({ ...response });
      setDemographicLoading(false);
    };
    const debouncedFetchData = useCallback(_debounce(fetchData, 500), [
      data.user_kapid_id,
    ]); // Adjust the debounce delay as needed

    useEffect(() => {
      // const source = patientService.getCancelTokenSource();

      // Call the debounced function when rowData.id changes
      debouncedFetchData();

      return () => {
        debouncedFetchData.cancel();
        controller.abort();
      };
    }, [data.user_kapid_id, debouncedFetchData, controller]);

    return (
      <>
        {demographicLoading ? (
          <Loader />
        ) : (
          <DemographicInfo user={demographic} user_type={"patient"} />
        )}
      </>
    );
  };

  return (
    <DataTableBase
      title="Patients"
      columns={columns}
      data={data}
      progressPending={loading}
      pagination
      paginationServer
      paginationTotalRows={totalRows}
      onChangeRowsPerPage={handlePerRowsChange}
      onChangePage={handlePageChange}
      sortServer
      onSort={handleSort}
      expandableRows
      expandableRowsComponent={ExpandedComponent}
    />
  );
};

export default PatientList;
